import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { API_TIMEOUT_TIERS } from '#pplx/frontend/api-clients/core/utils.js';
import { WEB_SOURCE, WEB_VERSION } from '#pplx/frontend/components/utils/consts.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { threadClient } from '#pplx_generated/typespec/rest/thread/client.js';
export const getThreadByUUID = async ({ slugOrUUID, headers, options, numRetries = 0, timeoutMs = API_TIMEOUT_TIERS.HIGH, reason, }) => {
    const fnName = 'getThreadByUUID';
    if (!slugOrUUID || slugOrUUID === 'undefined' || slugOrUUID === 'new') {
        logger.log(`Tried to ${fnName} with bad slugOrUUID: ${slugOrUUID}`);
        return;
    }
    const withParentInfo = options?.withParentInfo ?? false;
    const version = options?.version ?? WEB_VERSION;
    const source = options?.source ?? WEB_SOURCE;
    const limit = options?.limit ?? 0;
    const offset = options?.offset ?? 0;
    const fromFirst = options?.fromFirst ?? false;
    const withFirstEntry = options?.withFirstEntry ?? false;
    const withLatestEntry = options?.withLatestEntry ?? false;
    const supportedBlockUseCases = options?.supportedBlockUseCases ?? [];
    const cursor = options?.cursor ?? null;
    try {
        const { data, error, response } = await threadClient.GET('/rest/thread/{entry_uuid_or_slug}', reason, {
            params: {
                path: {
                    entry_uuid_or_slug: slugOrUUID,
                },
                query: {
                    with_parent_info: withParentInfo,
                    with_schematized_response: true,
                    version: version,
                    source: source,
                    limit: limit,
                    offset: offset,
                    from_first: fromFirst,
                    with_first_entry: withFirstEntry,
                    with_latest_entry: withLatestEntry,
                    supported_block_use_cases: supportedBlockUseCases,
                    cursor: cursor,
                },
            },
            timeoutMs,
            numRetries,
            headers,
        });
        // Failures can happen when user doesn't have permission to view thread
        if (!data || error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        // TypeSpec models serialized protobuf entries as Record<unknown>. Keep the
        // conversion at this API boundary so consumers use the actual entry shape.
        return data;
    }
    catch (err) {
        // API errors can contain the rejected path identifier in their response
        // body. Do not forward that user-controlled value to browser telemetry.
        logger.error('Failed to get thread by uuid');
        throw err;
    }
};
//# sourceMappingURL=getThreadByUUID.js.map